import { IconProps } from '.';

const LeaveIcon = ({
  color = 'var(--color-button-text-primary)',
  customClasses,
  ...rest
}: IconProps) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_9173_56182)">
        <path
          d="M12.4766 12.3459L27.1365 12.3459L8.64642 30.836L10.4142 32.6038L28.9043 14.1137L28.9043 28.7736L31.4043 28.7736L31.4043 11.0959L31.4043 9.84593L30.1543 9.84594L12.4766 9.84593L12.4766 12.3459Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_9173_56182">
          <rect width="40" height="40" fill="transparent" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LeaveIcon;
